/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {logoutApi} from 'src/app/modules/auth/core/_requests'
import {getCities} from 'src/app/modules/manage-party/parti-list/core/_requests'
import {getParty} from 'src/app/modules/party-entry/auto-vatav/_request'
import {setMessage} from 'src/store/alertMessage/actions'
import {removeAuth} from 'src/store/authDetail/actions'
import {getNotifications} from '../../header/_requests'
import {useEffect, useState} from 'react'
import HeaderNotificationsMenu from 'src/_metronic/partials/layout/header-menus/HeaderNotificationsMenu'
import { Logout } from 'src/app/modules/auth'
import LogoutConfirmation from 'src/app/modules/auth/components/LogoutConfirmation'
// Import your HeaderNotificationsMenu component
export const citylisting = async () => {
  try {
    const response = await getCities(); 
    return response.data.map((city: { id: number; city_name: string }) => ({
      label: city.city_name,
      value: city.id.toString(),
    }));
  } catch (error) {
    console.error("Error fetching cities:", error);
    return [];
  }
};

const SidebarMenuMain = () => {
  const intl = useIntl()
  const cityList = useSelector((state: any) => state?.commonList?.cityList)
  const isAdmin = cityList?.roleInfo?.id === 1 || cityList?.roleInfo?.id === 2
  const isPartyListPermission =
    cityList?.roleInfo?.id === 3 &&
    (cityList?.userPermissionInfo[0]?.party_is_list == true ||
      cityList?.userPermissionInfo[0]?.party_is_create == true ||
      cityList?.userPermissionInfo[0]?.party_is_edit === true ||
      cityList?.userPermissionInfo[0]?.party_is_view == true ||
      cityList?.userPermissionInfo[0]?.party_is_delete === true ||
      cityList?.userPermissionInfo[0]?.party_export === true)

  const isMessagePermission =
    cityList?.roleInfo?.id === 3 &&
    (cityList?.userPermissionInfo[0]?.message_is_list === true ||
      cityList?.userPermissionInfo[0]?.message_is_create === true ||
      cityList?.userPermissionInfo[0]?.message_is_edit === true ||
      cityList?.userPermissionInfo[0]?.message_is_view === true ||
      cityList?.userPermissionInfo[0]?.message_is_delete === true ||
      cityList?.userPermissionInfo[0]?.message_export === true)
  const isUserPermission =
    cityList?.roleInfo?.id === 3 &&
    (cityList?.userPermissionInfo[0]?.user_is_list === true ||
      cityList?.userPermissionInfo[0]?.user_is_create === true ||
      cityList?.userPermissionInfo[0]?.user_is_edit === true ||
      cityList?.userPermissionInfo[0]?.user_is_view === true ||
      cityList?.userPermissionInfo[0]?.user_is_delete === true ||
      cityList?.userPermissionInfo[0]?.user_export === true)
  const isChangePasswordPermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.change_password === true
  const isAuditLogsPermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.audit_logs === true

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const partyId = localStorage.getItem('id')
  // const logout = async (partyId: any) => {
  //   try {
  //     await logoutApi(partyId)
  //     dispatch(setMessage('success', 'Logout Successfully'))
      
  //     setTimeout(() => {
  //       localStorage.clear()
  //       dispatch(removeAuth())
  //       window.location.href = "/auth/login";
  //     }, 2000);
  //   } catch (err) {
  //     dispatch(setMessage('error', 'Logout failed'));
  //   } 
  // };
  
  const handleLogout = async () => {
    try {
      await logoutApi(partyId);
      dispatch(setMessage('success', 'Logout Successfully'));

      setTimeout(() => {
        localStorage.clear();
        dispatch(removeAuth());
        window.location.href = '/auth/login';
      }, 2000);
    } catch (err) {
      dispatch(setMessage('error', 'Logout failed'));
    }
  };

  // const logout = async () => {
  //   try {
  //     const userId = cityList?.id; // Ensure you fetch the correct user ID
  //     if (!userId) throw new Error('User ID not found');
  
  //     await logoutApi(userId);
  //     dispatch(setMessage('success', 'Logout Successfully'));
  //     localStorage.clear();
  //     dispatch(removeAuth());
  //     navigate('/auth/login');
  //     window.location.replace('/auth');
  //   } catch (err) {
  //     dispatch(setMessage('success', 'Logout Successfully'));
  //     localStorage.clear();
  //     dispatch(removeAuth());
  //     navigate('/auth/login');
  //   }
  // };
  
  
  
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen()
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    }
  }

  // Notification-related states and functions
  const [data, setData] = useState<any>([])
  const [isNotificationMenuOpen, setNotificationMenuOpen] = useState(false)

  const fetchData = async () => {
    try {
      await getNotifications()
        .then((data: any) => {
          if (data?.statusCode === 200 || data?.responseStatus === 200) {
            setData(data.responseData)
          }
        })
        .catch((error: any) => {
          if (error?.response?.data?.responseData?.msg) {
            console.log(error?.response?.data?.responseData?.msg)
          } else if (error?.response?.data?.responseMessage) {
            console.log(error?.response?.data?.responseMessage)
          } else {
            console.log(error)
          }
        })
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    // fetchData()
  }, [])

  return (
    <>
      {/* PARTIES */}
      <SidebarMenuItem
          to='/dashboard'
          title={intl.formatMessage({id: 'DASHBOARD'})}
          icon='/media/icons/duotune/general/gen022.svg'
          fontIcon='bi-person'
        />
      <SidebarMenuItemWithSub
        to='/partys'
        title={intl.formatMessage({id: 'PARTIES'})}
        icon='bi-person-fill'
        fontIcon='bi-person-fill'

      >
        <SidebarMenuItem
          to='/partys/list-party'
          title={intl.formatMessage({id: 'MANAGE.PARTY'})}
          hasBullet={true}
        />
        <SidebarMenuItem
          to='/partys/add-party'
          title={intl.formatMessage({id: 'ADD.PARTY'})}
          hasBullet={true}
          onClick={() => {
            citylisting()
          }}
        />
      </SidebarMenuItemWithSub>
      {/* PARTY ENTRY */}
      <SidebarMenuItemWithSub
        to='/party-entry'
        title={intl.formatMessage({id: 'PARTY.ENTRIES'})}
        icon='bi-wallet-fill'
        fontIcon='bi-wallet-fill'
      >
        <SidebarMenuItem
          to='/party-entry/auto-vatav'
          title={intl.formatMessage({id: 'AUTO.VATAV'})}
          hasBullet={true}
          // onClick={() => {
          //   getPartyListing()
          // }}
        />
        <SidebarMenuItem
          to='/party-entry/normal-entry'
          title={intl.formatMessage({id: 'NORMAL.ENTRY'})}
          hasBullet={true}
        />
      </SidebarMenuItemWithSub>
      {/* REPORT */}
      <SidebarMenuItemWithSub
        to='/report'
        title={intl.formatMessage({id: 'REPORTS'})}
        icon='bi-pie-chart-fill'
        fontIcon='bi-pie-chart-fill'
      >
        <SidebarMenuItem to='/report/party-ledger' title='Party Ledger' hasBullet={true} />
        <SidebarMenuItem to='/report/general-ledger' title='General Ledger' hasBullet={true} />
        <SidebarMenuItem to='/report/transactions' title='Transactions' hasBullet={true} />
        <SidebarMenuItem to='/report/deleted-transactions' title='DeletedTransactions' hasBullet={true} />
        <SidebarMenuItem to='/report/recalculate' title='Recalculate' hasBullet={true} />
        <SidebarMenuItem to='/report/city-wise' title='Citywise Closing' hasBullet={true} />
      </SidebarMenuItemWithSub>
      {/* Change Password */}
      <SidebarMenuItem
        to='/change-password'
        title='Change Password'
        icon='bi-gear-fill'
        fontIcon='bi-gear-fill'
      />
      {/* <SidebarMenuItem
        to='#'
        title={intl.formatMessage({id: 'LOGOUT'})}
        icon='bi-box-arrow-right'
        fontIcon='bi-box-arrow-right'
        onClick={() => 
          logout(partyId)
        }
      /> */}
        <SidebarMenuItem
        to="#"
        title="Logout"
        icon="bi-box-arrow-right"
        fontIcon="bi-box-arrow-right"
        onClick={() => setShowLogoutModal(true)}
      />

      <LogoutConfirmation
        show={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={handleLogout}
      />
        
    </>
  )
}

export {SidebarMenuMain}
